export const t_global_breakpoint_height_md = {
  "name": "--pf-t--global--breakpoint--height--md",
  "value": "40rem",
  "var": "var(--pf-t--global--breakpoint--height--md)"
};
export default t_global_breakpoint_height_md;